<template>
  <div>
    <template v-if="!folderId">
      <p>Choose a message folder to see messages inside:</p>
      <ul>
        <li v-for="folder in folders" :key="folder.id">
          <a @click="folderId = folder.id">{{ folder.name }}</a>
        </li>
      </ul>
    </template>
    <template v-if="folderId">
      <p>Choose a standard response:</p>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
      <v-data-table
        :headers="headers"
        :items="responses"
        :search="search"
        class="elevation-1"
        v-if="responses"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.body }}</td>
            <td>
              <v-btn
                small
                @click="createMessage(props.item)"
                :disabled="submitted"
                >select</v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <v-btn @click="$emit('reset')">Cancel</v-btn>
  </div>
</template>

<script>
import FOLDERS from "@/graphql/message/Folders";
import FOLDER_RESPONSES from "@/graphql/message/FolderResponses";
export default {
  name: "StandardResponse",
  apollo: {
    folders: {
      query: FOLDERS,
      fetchPolicy: "cache-and-network"
    },
    responses: {
      query: FOLDER_RESPONSES,
      variables() {
        return {
          id: this.folderId
        };
      },
      update: (data) => data.folder.responses,
      skip() {
        return !this.folderId;
      },
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      folderId: null,
      headers: [
        {
          text: "Body",
          sortable: true,
          value: "body"
        },
        {
          text: " ",
          sortable: false,
          value: null
        }
      ],
      search: "",
      submitted: false
    };
  },
  methods: {
    createMessage(response) {
      if (confirm("Are you sure?")) {
        this.submitted = true;
        this.$emit("create", {
          responseId: response.id
        });
      }
    }
  }
};
</script>

<style scoped>
.input-group label {
  text-overflow: unset;
}
</style>
